// src/routes/Routes.tsx
// ----------------------------------------------------------------------
import React, { Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { LayoutTypes } from '../constants/layout';
import type { RootState } from '../redux/store';

import DefaultLayout     from '../layouts/Default';
import VerticalLayout    from '../layouts/Vertical';
import DetachedLayout    from '../layouts/Detached';
import HorizontalLayout  from '../layouts/Horizontal/';
import TwoColumnLayout   from '../layouts/TwoColumn/';

import {
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
} from './index';

const AllRoutes: React.FC = () => {
  const layoutState  = useSelector((s: RootState) => s.Layout);
  const userLoggedIn = useSelector((s: RootState) => s.Auth.userLoggedIn);
  const location     = useLocation();

  // Debug: ¿a dónde estás navegando?
  console.log('🌍 Navegando a:', location.pathname);

  const layout = {
    ...layoutState,
    showRightSidebar: layoutState.isOpenRightSideBar,
  };

  const getLayout = () => {
    switch (layoutState.layoutType) {
      case LayoutTypes.LAYOUT_HORIZONTAL: return HorizontalLayout;
      case LayoutTypes.LAYOUT_DETACHED:   return DetachedLayout;
      case LayoutTypes.LAYOUT_VERTICAL:   return VerticalLayout;
      default:                            return TwoColumnLayout;
    }
  };
  const Layout = getLayout();

  return (
    <Suspense fallback={<div>Cargando...</div>}>
      <Routes>
        {/*
          1) RUTAS PÚBLICAS (incluyen TODO /auth/*)
        */}
        {publicProtectedFlattenRoutes.map((route, idx) =>
          route.path?.startsWith('/auth/') ? (
            // estas van **sin** DefaultLayout
            <Route key={idx} path={route.path!} element={route.element} />
          ) : (
            // resto de públicas con DefaultLayout
            <Route
              key={idx}
              path={route.path!}
              element={<DefaultLayout layout={layout}>{route.element}</DefaultLayout>}
            />
          )
        )}

        {/*
          2) RUTAS PROTEGIDAS (filtramos TODO lo que empiece por /auth/)
        */}
        {authProtectedFlattenRoutes
          .filter((route) => !route.path?.startsWith('/auth/'))
          .map((route, idx) => (
            <Route
              key={idx}
              path={route.path!}
              element={
                !userLoggedIn
                  ? <Navigate to={`/auth/login?next=${route.path}`} replace />
                  : <Layout>{route.element}</Layout>
              }
            />
        ))}

        {/*
          3) RUTA Fallback para ver si algo no está mapeado
        */}
        <Route
          path="*"
          element={<div>❌ No hay ruta para “{location.pathname}”</div>}
        />
      </Routes>
    </Suspense>
  );
};

export default AllRoutes;
